<template>
  <div class="background qb-color-1">
      <!-- <div class="nav qb-padding" >
          <span class="qb-txt-white" style="display: flex; width:10%; align-items: center;" @mouseover="menuAtivo = true" @mouseleave="menuAtivo = false">Menu <span style="font-size:24px; color: #a7acb2;" class="mdi mdi-menu-down"></span></span>
          <div @mouseover="menuAtivo = true" @mouseleave="menuAtivo = false" v-show="menuAtivo" class="menu-content qb-container" style="width: 200px;">
           <i class="seta-cima"/>
            <nav >
              <ul>
                <li v-for="menu in menuItens" :key="menu.menu.id" style="width: 140%;">
                  <div class="menu-item">
                    {{menu.menu.description}}
                  </div>
                    <ul class="sub-menu-item qb-padding">
                      <li>
                        <a href="#" @click.prevent="openSection(menu.menu)">
                           {{menu.menu.description}} 
                        </a>
                      </li>
                      <li v-for="subMenuItem in menu.subMenu" :key="subMenuItem.id">
                        <a href="#" @click.prevent="openSection(subMenuItem)">
                           {{subMenuItem.description}} 
                        </a>
                      </li>
                    </ul>
                </li>
              </ul>
            </nav>
          </div>
          
          <router-link to="/">
            <span class="qb-txt-white">home</span>
          </router-link>
      </div> -->
    <div class="menu-mobile color-bg">
      <div class="qb-container">
        <div>
          <Menu class="md-36 white" @click="abrirMenu()"/>
          <nav v-if="abrir">
                <!-- <ul>
                  <li v-for="menu in menuItens" :key="menu.menu.id" style="width: 140%;">
                    <span class="" @click="abrirSubMenu()">
                      {{menu.menu.description}}
                    </span>
                    <ul v-if="subMenuAbrir">
                      <li v-for="subMenuItem in menu.subMenu" :key="subMenuItem.id">
                        {{subMenuItem.description}} 
                      </li>
                    </ul>
                  </li>
                </ul> -->
                <badger-accordion>
                  <badger-accordion-item v-for="menu in menuItens" :key="menu.menu.id">
                      <template slot="header">{{menu.menu.description}}</template>    
                      <template slot="content"  >
                        <div class="sub-menu"  @click.prevent="openSection(subMenuItem, $event)" v-for="subMenuItem in menu.subMenu" :key="subMenuItem.id">
                          <span>{{subMenuItem.description}}</span>
                        </div>
                          <!-- <badger-accordion>
                            <badger-accordion-item v-for="subMenuItem in menu.subMenu" :key="subMenuItem.id" >
                              <template slot="header"><span  @click.prevent="openSection(subMenuItem)">{{subMenuItem.description}}</span></template>   
                              </badger-accordion-item>
                            </badger-accordion> -->
                        </template>   
                  </badger-accordion-item>
              </badger-accordion>
            </nav>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Menu from "vue-material-design-icons/Menu.vue";
import { baseApiUrl, userKey } from '@/global';
import CreditCard from "vue-material-design-icons/CreditCard.vue";
import Account from "vue-material-design-icons/Account.vue";

import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';

export default {
  components:{
    Menu,
    BadgerAccordion,
    BadgerAccordionItem,
    CreditCard,
    Account,
    vSelect

  },
  data(){
    return {
      menuAtivo: false,
      menuItens: [],
      abrir: false,
      subMenuAbrir: false,
      itemAtivo: ''
      
    }
  },
  methods:{
    montaMenu(){
      axios.get(`${baseApiUrl}/category/menu`)
      .then(res => {
        this.menuItens = res.data;
        this.menuAtivo = false;
      })
    },
    abrirMenu(){
      this.abrir = !this.abrir;
    },
    abrirSubMenu(){
      this.subMenuAbrir = !this.subMenuAbrir
    },
    openSection(item,event) {
      if(this.itemAtivo){
        if(this.itemAtivo.target.localName == 'span')
          this.itemAtivo.target.parentElement.classList.remove('selecionado');
        else
          this.itemAtivo.target.classList.remove('selecionado');
      }
      
      this.itemAtivo = event;
      
      if(event.target.localName == 'span')
        event.target.parentElement.classList.add('selecionado');
      else
        event.target.classList.add('selecionado');
      // this.$router.push(this.getUrl(item));
      this.abrirMenu();
      this.$router.push({ name: 'lista', 
      query:{ 
        //marcas: this.$route.query.marcas, 
        //params: this.$route.query.params, 
        pagina: 1,
        idCategoria: item.classificationId,
        // ofertas: this.$route.query.ofertas,
        // novidades: this.$route.query.novidade
      }})
    },
    getUrl(item) {
      return `/lista/${item.classificationId}/1`;
    },
  },
  mounted(){
    this.montaMenu();  
  }
}
</script>

<style >
.selecionado{
background-color: #84848469;
}
.badger-toggle-indicator{
  color:#000;
}
.sub-menu{
   padding: 8px 8px;
   cursor: pointer;
}
.sub-menu:hover{
   background-color: #84848469;
}
.js-badger-accordion-header.-ba-is-active{
  background-color: #006f3a;
}

.js-badger-accordion-header:hover{
  background-color: #006f3a;
}

.js-badger-accordion-header{
  padding: 8px 0;
}
.js-badger-accordion-panel-inner{
  background-color: #fff;
}
.badger-accordion__panel.js-badger-accordion-panel{
  margin-left: 0;
}
.js-badger-accordion-header.-ba-is-active .badger-accordion-title{
  color: #FFF;
}
.component-badger-accordion.badger-accordion--initialized{
  background: #FFF;
}
/* .nav{
    width: 70%;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.nav .menu-content{
  background-color: #ffffff;
  position: absolute;
  z-index: 999999;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.13);
  border: 1px solid rgba(0,0,0,.13);
  /*border-radius: 4px;*/
  /* margin-left: 28px; */
  /* top: 100px; */
/* }  */
nav{
  padding-bottom: 8px;
}
nav li{
  list-style: none;
  line-height: 2em;
}
.white{
  color: #fff
}
/* .menu-item:hover{
  color:orangered; 
}

.seta-cima{
  position: absolute;
  top: -15px;
}

.seta-cima:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 0; 
  height: 0; 
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid white;

}
.sub-menu-item{
  width: 110%;
  display: none;
  position: absolute;
  top: -1px;
  left: 200px;
  background: #fff;
  height: auto;
  min-height: 100%;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.13);
  border: 1px solid rgba(0,0,0,.13);
  /*border-radius: 0 4px 4px;*/ 
/*}*/
/* .sub-menu-item li a:hover{ */
  /* color:orangered; */
/* } */
.color-bg{
   background-color: #006f3a;
 }

.menu-mobile{
   padding-bottom: 16px;
   display: none;
 }
/* nav ul ul {
    display: none;
}
nav ul li:hover > ul {
    display: block;
}
nav ul ul{
  position: absolute; left: 102%; top:0;
} */


@media screen and (max-width: 900px) {
    .color-bg{
      background-color: #006f3a;
      
    }
    .menu-mobile{
      padding-bottom: 0;
      display: block;
    }
    .js-badger-accordion-header.-ba-is-active{
      background-color: #006f3a;
    }
    .component-badger-accordion.badger-accordion--initialized{
      background: #DFDFDF80;
    }

    .badger-toggle-indicator{
      color:#fff;
    }

    .btn.btn-primary.btn-add-vinculo{
        margin-left: 65% !important;
        margin-top:100% !important;
      }

      .btn.btn-primary.btn-vincular{
        display: none;
      }
          
}

.btn.btn-primary.btn-vincular{
  margin-left: 73%;
  margin-top: 0;
  width: auto;
  height: auto;
}
.btn.btn-primary.btn-add-vinculo{
  float: right;
}

.vinculo{
  padding: 20px;
  height: 500px;
}
</style>